import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  submit(event) {
    event.preventDefault()
    if (this.buttonTarget.disabled) return

    const value = this.inputTarget.value.toString().trim()
    if (!value) return

    this.buttonTarget.disabled = true
    this.dispatch("submit", { detail: { value } })
  }

  submitOnEnter(event) {
    if (event.key !== "Enter") return
    if (event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) return

    this.submit(event)
  }
}
